// 覚醒王の「予備動作の間はボスを主人公の前に描く」比較版 (DEV `?awokenFaceFront=1`・2026-10-27)。既定 (指定なし) = 配布版のまま。
//   作者 (10-27)「攻撃の予備動作の時に見るべき顔の先のあたりがLUNAIREと被っていて見えにくい」。
//   配布版は主人公をボスの後に描く (render.ts) ので、顔が主人公の頭の上に来ると顔の方が隠れる。
//   間合い (?awokenFaceRoom=1) では壁際・詰めてくる主人公の時に直らない (docs/research/2026-10-27-awoken-face-overlap.md)。
//   比較版: 覚醒王の予備動作の間だけ、描く順を入れ替えて主人公を先に描く。当たり・動き・間合いは変えない。
import type { Boss } from './types'

let enabled = false
/** DEV の切り替え (game.ts)。'1' = 比較版。 */
export function setAwokenFaceFront(v: string | null): boolean { enabled = v === '1'; return enabled }
/** 主人公をボスより先に描く時だけ true (比較版・覚醒王・予備動作の間)。 */
export function awokenFaceFrontActive(boss: Pick<Boss, 'id' | 'state'> | null | undefined): boolean {
  return enabled && !!boss && boss.id === 'crowned-king-awoken' && boss.state === 'telegraph'
}
// ボスの奥へ回した主人公を、手前に薄く重ねる濃さ (0 = 重ねない)。
export const AWOKEN_FACE_FRONT_GHOST_ALPHA = 0.35
